import localConfig from './local.js';
import envVarsConfig from './env_vars.js';
import testConfig from './test.js';

const environment = import.meta.env.VITE_ENV || 'local';

const configMap = {
  local: localConfig,
  env_vars: envVarsConfig,
  test: testConfig,
};

let config;
if (typeof window !== 'undefined' && window.CUSTOM_CONFIG) {
  // Merge: CUSTOM_CONFIG (from Express) over the baked-in env vars config.
  // This ensures any value not provided by the server falls back to what
  // Vite baked in at build time (e.g. Firebase config in local dev).
  const base = configMap[window.CUSTOM_CONFIG.environment] || configMap[environment] || localConfig;
  config = { ...base, ...window.CUSTOM_CONFIG };
} else {
  config = configMap[environment] || localConfig;
}

export default config;
